module.exports = __webpack_public_path__ + "img/m_role_6_name.a7e56800.png";